import m from "../_lib/toInteger/index.mjs";
import a from "../toDate/index.mjs";
import i from "../_lib/requiredArgs/index.mjs";
function d(t, r) {
  i(2, arguments);
  var e = a(t).getTime(), o = m(r);
  return new Date(e + o);
}
export {
  d as default
};
